<template>
  <div class="wrapper">
    <!-- 头部状态栏 -->
    <div class="header">
      <div class="headerBox">
        <div class="stateArea">
          <span
            v-if="
              info.refund_state == 3 &&
              (info.refund_type == '1' ||
                info.refund_type == '2' ||
                info.refund_type == '4' ||
                info.refund_type == '8')
            "
            class="stateText"
            >退款成功</span
          >
          <span
            v-if="
              info.refund_state == 4 &&
              (info.refund_type == '1' ||
                info.refund_type == '2' ||
                info.refund_type == '4'||
                info.refund_type == '8')
            "
            class="stateText"
            >退款失败</span
          >
          <span
            v-if="
              info.refund_state == 5 &&
              (info.refund_type == '1' ||
                info.refund_type == '2' ||
                info.refund_type == '4'||
                info.refund_type == '8')
            "
            class="stateText"
            >取消退款</span
          >
          <span
            v-if="info.refund_state == 3 && (info.refund_type == 3||info.refund_type == 9)"
            class="stateText"
            >退款退货成功</span
          >
          <span
            v-if="info.refund_state == 4 && (info.refund_type == 3||info.refund_type == 9)"
            class="stateText"
            >退款退货失败</span
          >
          <span
            v-if="info.refund_state == 5 && (info.refund_type == 3||info.refund_type == 9)"
            class="stateText"
            >取消退款退货</span
          >
          <span
            v-if="info.refund_state == 3 && info.refund_type == 5"
            class="stateText"
            >换货成功</span
          >
          <span
            v-if="info.refund_state == 4 && info.refund_type == 5"
            class="stateText"
            >换货失败</span
          >
          <span
            v-if="info.refund_state == 5 && info.refund_type == 5"
            class="stateText"
            >取消换货</span
          >
          <span
            v-if="info.refund_state == 3 && info.refund_type == 6"
            class="stateText"
            >补偿成功</span
          >
          <span
            v-if="info.refund_state == 4 && info.refund_type == 6"
            class="stateText"
            >补偿失败</span
          >
          <span
            v-if="info.refund_state == 5 && info.refund_type == 6"
            class="stateText"
            >取消补偿</span
          >
          <span
            v-if="info.refund_state == 3 && info.refund_type == 7"
            class="stateText"
            >补发成功</span
          >
          <span
            v-if="info.refund_state == 4 && info.refund_type == 7"
            class="stateText"
            >补发失败</span
          >
          <span
            v-if="info.refund_state == 5 && info.refund_type == 7"
            class="stateText"
            >取消补发</span
          >
          <span v-if="info.refund_state == 1" class="stateText"
            >申请已提交，请耐心等待审核…</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (info.refund_type == 3||info.refund_type == 9) &&
              (!info.pickup_state ||
                (info.pickup_state &&
                  (info.pickup_state == 4 || info.pickup_state == 5))) &&
              !info.refund_express_id &&
              !info.back_full_address
            "
            class="stateText"
            >申请已提交，请耐心等待审核…</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (info.refund_type == 3||info.refund_type == 9) &&
              (!info.pickup_state ||
                (info.pickup_state &&
                  (info.pickup_state == 4 || info.pickup_state == 5))) &&
              !info.refund_express_id &&
              info.back_full_address
            "
            class="stateText"
            >商家已同意退货，请将商品寄回吧</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (info.refund_express_id || ((info.pickup_state == 3||info.pickup_state == 6)&&info.pickup.pay_state=='2')) &&
              (info.refund_type == 3||info.refund_type == 9)
            "
            class="stateText"
            >等待退款</span
          >
           <span
            v-if="
              info.refund_state == 2 &&
              (info.refund_express_id || ((info.pickup_state == 3||info.pickup_state == 6)&&info.pickup.pay_state=='2')) &&
              (info.refund_type == 5)
            "
            class="stateText"
            >换货中</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              !info.refund_express_id &&
              (!info.pickup_state ||
                (info.pickup_state &&
                  (info.pickup_state == 4 || info.pickup_state == 5))) &&
              info.refund_type == 5 &&
              !info.back_full_address
            "
            class="stateText"
            >申请已提交，请耐心等待审核…</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              !info.refund_express_id &&
              (!info.pickup_state ||
                (info.pickup_state &&
                  (info.pickup_state == 4 || info.pickup_state == 5))) &&
              info.refund_type == 5 &&
              info.back_full_address
            "
            class="stateText"
            >商家已同意换货，请将商品寄回吧</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (!info.pickup_state ||
                (info.pickup_state &&
                  (info.pickup_state == 4 || info.pickup_state == 5))) &&
              info.refund_type == 7
            "
            class="stateText"
            >等待补货发货</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              info.pickup_state == 1 &&
              (info.refund_type == 3 || info.refund_type == 5 ||info.refund_type == 9)
            "
            class="stateText"
            >等待快递员接单</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (((info.pickup_state == 3 || info.pickup_state == 6)&&info.pickup&&info.pickup.pay_state=='1')) &&
              info.refund_type == 5
            "
            class="stateText"
            >{{info.pickup&&info.pickup.pay_state=='1'?'快递员已取件，请支付快递金额':'换货中'}}</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              info.pickup_state == 2 &&
              (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
            "
            class="stateText"
            >等待快递员揽件</span
          >
          <span
            v-if="
              info.refund_state == 2 &&
              (((info.pickup_state == 3 || info.pickup_state == 6)&&info.pickup&&info.pickup.pay_state=='1')) &&
              (info.refund_type == 3 ||info.refund_type == 9)
            "
            class="stateText"
            > {{info.pickup&&info.pickup.pay_state=='1'?'快递员已取件，请支付快递金额':'退货退款中'}}</span
          >
        </div>
        <div class="time">
          <span>{{ info.update_time }}</span>
        </div>
        <div class="process">
          <div class="spot"></div>
          <div class="line"></div>

          <div
            v-if="
              info.refund_type == '1' ||
              info.refund_type == '2' ||
              info.refund_type == '4' ||
              info.refund_type == 6 ||
              info.refund_type == 7 ||
                info.refund_type == '8'
            "
            :class="{ spot: true, active: info.refund_state == 1 }"
          ></div>
          <div
            v-if="info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9"
            :class="{
              spot: true,
              active:
                !info.back_full_address &&
                (info.refund_state == 2 || info.refund_state == 1),
            }"
          ></div>

          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == '1' ||
                info.refund_type == '2' ||
                info.refund_type == '4' ||
                info.refund_type == 6 ||
                info.refund_type == 7||
                info.refund_type == '8')
            "
            :class="{ line: true, disabled: info.refund_state < 2 }"
          ></div>
          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == '1' ||
                info.refund_type == '2' ||
                info.refund_type == '4' ||
                info.refund_type == 6 ||
                info.refund_type == 7||
                info.refund_type == '8')
            "
            :class="{
              spot: true,
              active: info.refund_state == 2,
              disabled: info.refund_state < 2,
            }"
          ></div>

          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == '3' || info.refund_type == '5'|| info.refund_type == '9')
            "
            :class="{
              line: true,
              disabled: !info.back_full_address && info.refund_state < 3,
            }"
          ></div>
          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == '3' || info.refund_type == '5'|| info.refund_type == '9')
            "
            :class="{
              spot: true,
              active:
                ((info.refund_type == '3'|| info.refund_type == '9') &&
                  info.back_full_address &&
                  info.refund_state == 2 &&
                  (!info.pickup_state ||
                    (info.pickup_state && 
                      (info.pickup_state == 4 || info.pickup_state == 5||info.pickup.pay_state != 2))) &&
                  !info.refund_express_id) ||
                (info.refund_type == '5' &&
                  info.back_full_address &&
                  info.refund_state == 2),
              disabled: !info.back_full_address && info.refund_state < 3,
            }"
          ></div>

          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
            "
            :class="{
              line: true,
              disabled:
                (info.refund_type == 5 && info.refund_state < 3) ||
                ((info.refund_type == 3||info.refund_type == 9) &&
                  (!info.pickup_state ||
                    (info.pickup_state&&info.pickup&& info.pickup.pay_state != 2)||(info.pickup_state==4||info.pickup_state==5)) &&
                  !info.refund_express_id),
            }"
          ></div>
          <div
            v-if="
              info.refund_state != 4 &&
              info.refund_state != 5 &&
              (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
            "
            :class="{
              spot: true,
              active:
                (info.refund_type == 3||info.refund_type == 9) &&
                info.refund_state == 2 &&
                (info.refund_express_id || ((info.pickup_state == 3||info.pickup_state == 6)&&info.pickup&&info.pickup.pay_state=='2')),
              disabled:
                (info.refund_type == 5 && info.refund_state < 3) ||
                ((info.refund_type == 3||info.refund_type == 9) &&
                  (!info.pickup_state ||
                    (info.pickup_state && info.pickup&&info.pickup.pay_state != 2)||(info.pickup_state==4||info.pickup_state==5)) &&
                  !info.refund_express_id),
            }"
          ></div>

          <div :class="{ line: true, disabled: info.refund_state < 3 }"></div>
          <div
            :class="{
              spot: true,
              active: info.refund_state > 2,
              disabled: info.refund_state < 3,
            }"
          ></div>
        </div>
        <div
          v-if="info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9"
          class="processName"
        >
          <span class="processItemName">提交申请</span>
          <span
            :class="{
              processItemName: true,
              active:
                !info.back_full_address &&
                (info.refund_state == 2 || info.refund_state == 1),
            }"
            >商家处理</span
          >

          <span
            v-if="info.refund_state != 4 && info.refund_state != 5"
            :class="{
              processItemName: true,
              disabled: !info.back_full_address && info.refund_state < 3,
              active:
                ((info.refund_type == '3'|| info.refund_type == '9') &&
                  info.back_full_address &&
                  info.refund_state == 2 &&
                  (!info.pickup_state ||
                    (info.pickup_state &&
                      (info.pickup_state == 4 || info.pickup_state == 5))) &&
                  !info.refund_express_id) ||
                (info.refund_type == '5' &&
                  info.back_full_address &&
                  info.refund_state == 2),
            }"
            >寄回商品</span
          >

          <span
            v-if="
              (info.refund_type == 3||info.refund_type == 9) &&
              info.refund_state != 4 &&
              info.refund_state != 5
            "
            :class="{
              processItemName: true,
              disabled: info.refund_state < 3,
              active:
                info.refund_state == 2 &&
                (info.refund_express_id || ((info.pickup_state == 3||info.pickup_state == 6)&&info.pickup&&info.pickup.pay_state=='2')),
            }"
            >退货中</span
          >
          <span
            v-if="
              info.refund_type == 5 &&
              info.refund_state != 4 &&
              info.refund_state != 5
            "
            :class="{ processItemName: true, disabled: info.refund_state < 3 }"
            >商家发货</span
          >

          <span v-if="info.refund_state == 4" class="processItemName active"
            >{{ (info.refund_type == 3||info.refund_type == 9) ? "退货" : "换货" }}失败</span
          >
          <span
            v-else-if="info.refund_state == 5"
            class="processItemName active"
            >取消{{ (info.refund_type == 3||info.refund_type == 9) ? "退货" : "换货" }}</span
          >
          <span
            v-else
            :class="{
              processItemName: true,
              disabled: info.refund_state < 3,
              active: info.refund_state == 3,
            }"
            >{{ (info.refund_type == 3||info.refund_type == 9) ? "退款" : "换货" }}成功</span
          >
        </div>
        <div
          v-if="
            info.refund_type == '1' ||
            info.refund_type == '2' ||
            info.refund_type == '4' ||
            info.refund_type == 6 ||
            info.refund_type == 7||
            info.refund_type == '8'
          "
          class="processName"
        >
          <span class="processItemName">提交申请</span>
          <span
            :class="{ processItemName: true, active: info.refund_state == 1 }"
            >商家处理</span
          >
          <span
            v-if="info.refund_state != 4 && info.refund_state != 5"
            :class="{
              processItemName: true,
              disabled: info.refund_state < 2,
              active: info.refund_state == 2,
            }"
            >商家{{
              info.refund_type == "1" ||
              info.refund_type == "2" ||
              info.refund_type == "4" ||
              info.refund_type == "8"
                ? "退款"
                : info.refund_type == 6
                ? "补偿"
                : info.refund_type == 7
                ? "发货"
                : ""
            }}</span
          >
          <span v-if="info.refund_state == 4" class="processItemName active"
            >{{
              info.refund_type == "1" ||
              info.refund_type == "2" ||
              info.refund_type == "4" ||
              info.refund_type == "8"
                ? "退款"
                : info.refund_type == 6
                ? "补偿"
                : info.refund_type == 7
                ? "补发"
                : ""
            }}失败</span
          >
          <span
            v-else-if="info.refund_state == 5"
            class="processItemName active"
            >取消{{
              info.refund_type == "1" ||
              info.refund_type == "2" ||
              info.refund_type == "4" ||
              info.refund_type == "8"
                ? "退款"
                : info.refund_type == 6
                ? "补偿"
                : info.refund_type == 7
                ? "补发"
                : ""
            }}</span
          >
          <span
            v-else
            :class="{
              processItemName: true,
              disabled: info.refund_state < 3,
              active: info.refund_state == 3,
            }"
            >{{
              info.refund_type == "1" ||
              info.refund_type == "2" ||
              info.refund_type == "4" ||
              info.refund_type == "8"
                ? "退款"
                : info.refund_type == 6
                ? "补偿"
                : info.refund_type == 7
                ? "补发"
                : ""
            }}成功</span
          >
        </div>
      </div>
    </div>
    <!-- 头部状态栏 -->
    <!--<div
      class="topNotice"
      v-if="info.refund_state==2&&(!info.pickup_state||info.pickup_state&&(info.pickup_state==4||info.pickup_state==5))&&!info.refund_express_id&&info.refund_type==5"
    >商家已同意您的换货申请，请把商品寄回吧</div>
    <div
      class="topNotice"
      v-if="info.refund_state==2&&(!info.pickup_state||info.pickup_state&&(info.pickup_state==4||info.pickup_state==5))&&!info.refund_express_id&&info.refund_type==3"
    >商家已同意您的退货申请，请把商品寄回吧</div>
    <div
      class="topNotice"
      v-if="info.refund_express_id&&info.refund_state==2
      &&(info.refund_type==3||info.refund_type==5)"
    >商品已寄回，等待商家确认收货</div>
    <div class="topNotice" v-if="info.refund_state==1&&info.refund_type==7">您已成功发起补货申请，请耐心等待商家审核</div>
    <div class="topNotice" v-if="info.refund_state==1&&info.refund_type==6">您已成功发起补偿申请，请耐心等待商家审核</div>
    <div class="topNotice" v-if="info.refund_state==1&&info.refund_type==5">您已成功发起换货申请，请耐心等待后台审核</div>
    <div
      class="topNotice"
      v-if="info.refund_state == 3 &&
     (info.refund_type == 7||info.refund_type == 5)"
    >感谢使用本次服务。</div>
    <div
      class="topNotice"
      v-if="info.refund_state==1&&(info.refund_type=='1'||info.refund_type=='2'||info.refund_type=='4')"
    >您已成功发起退款申请，请耐心等待后台审核</div>-->
    <!-- 物流基本信息 -->

    <div class="postAddress" v-if="(stateType == 1||stateType == 2)&&info.address&&info.address.address">
      <span class="postKey" style="color: #333">退货地址:</span>
      <div class="right">
        <div class="postTop">
          <div class="left" style="height:.4rem">
            <span style="margin-right: 0.1rem">{{
              info.is_pickup == '1'?info.address.contact:info.address.contact_self
            }}</span>
            <span>{{ info.is_pickup == '1'?info.address.phone_no:info.address.phone_no_self }}</span>
            
          </div>
          <div
            v-if="info.is_pickup == '0'"
            class="copyBtn"
            @click="copy"
            data-clipboard-action="copy"
            :data-clipboard-text="`${info.contact_self},${info.phone_no_self},${info.province_self}${info.city_self}${info.district_self}${info.address_self}`"
          >
            <span>复制地址</span>
          </div>
        </div>
        <span v-if="info.is_pickup == '1'" style="word-break: break-all;line-height:.32rem;">{{info.address.province}}{{info.address.city}}{{info.address.district}}{{info.address.address}}</span>
        <span v-else style="word-break: break-all;line-height:.32rem;">{{info.address.province_self}}{{info.address.city_self}}{{info.address.district_self}}{{info.address.address_self}}</span>
      </div>
    </div>

    <!-- 上门取件数据栏 -->
    <div v-if="stateType == 2">
      <div
        v-if="
          info.pickup &&
          info.pickup.contact_sender &&
          info.refund_state == 2 &&
          info.pickup_state == 1 &&
          (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
        "
      >
        <div class="itemArea">
          <span class="key">取件地址</span>
          <div class="selectRight">
            <div style="flex: 1">
              <div class="flex">
                <span>{{ info.pickup.contact_sender }}</span>
                <span>{{ info.pickup.phone_no_sender }}</span>
              </div>
              <div style="margin-top: 0.1rem; word-break: break-all">
                {{ info.pickup.address_sender }}
              </div>
            </div>
          </div>
        </div>
        <div class="itemArea" v-if="info.pickup.start_time">
          <span class="key">取件时间</span>
          <div class="selectRight" style="justify-content: flex-start">
            <span>{{ info.pickup.start_time.substring(0, 16) }}-{{info.pickup.end_time.substring(11, 16)}}</span>
          </div>
        </div>
        <div class="itemArea">
          <span class="key">商品重量</span>
          <div class="selectRight" style="justify-content: flex-start;">
            <span>{{info.pickup.weight}}KG</span>
          </div>
        </div>
      </div>
      <div
        v-if="
          info.pickup &&
          info.pickup.pay_state == '1'&&
          info.refund_state == 2 &&
          (info.pickup_state == 2||info.pickup_state == 3||info.pickup_state == 6) &&
          (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
        "
      >
        <div class="itemArea">
          <span class="key">快递员</span>
          <div class="selectRight">
            <div style="flex: 1">
              <div class="flex">
                <span>{{ info.pickup.person_name }}</span>
                <span>{{ info.pickup.person_phone }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="itemArea" v-if="info.pickup.pickup_code">
          <span class="key">取件码</span>
          <div class="selectRight">
            <div style="flex: 1">
              <div class="flex">
                <span style="font-size: 0.36rem">{{
                  info.pickup.pickup_code
                }}</span>
                <span style="font-size: 0.24rem; color: #e52b25"
                  >快递员上门前请勿提供！</span
                >
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="itemArea">
            <span class="key">商品重量</span>
            <div class="selectRight">
              <div style="flex:1;">
                <div class="flex">
                  <span>{{ info.pickup.weight}}KG</span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="itemArea"
            v-if="info.pickup.start_time"
          >
            <span class="key">取件时间</span>
            <div class="selectRight">
              <div style="flex: 1">
                <div class="flex">
                  <span>{{ info.pickup.start_time.substring(0, 16) }}-{{info.pickup.end_time.substring(11, 16)}}</span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
          <div class="itemArea" v-if="parseFloat(info.pickup.amount||'0') > 0">
            <span class="key">运费金额</span>
            <div class="selectRight">
              <div style="flex:1;">
                <div class="flex">
                  <span>￥{{info.pickup.amount}}</span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="express" v-if="stateType == 3">
      <!--<div class="topList" style="margin-bottom: .2rem">
        <div class="flexItem">
          <span>退单编号：{{info.refund_nbr}}</span>
        </div>
      </div> -->
      <div class="top" v-if="info.commodity">
        <div class="left">
          <img :src="info.commodity[0].commodity_logo" alt />
        </div>
        <div class="right">
          <span>
            <span>承运来源：</span>
            <span>{{ info.supply_express_name }}</span>
          </span>
          <!-- <span>
            <span>官方电话：</span>
            <span>{{'95547'}}</span>
          </span>-->
          <span>
            <span>物流状态：</span>
            <span v-if="status == 1" class="bold">已揽件</span>
            <span v-else-if="status == 2 && statusEx == 202" class="bold"
              >派件中</span
            >
            <span v-else-if="status == 2" class="bold">在途中</span>
            <span v-else-if="status == 3" class="bold">已签收</span>
            <span v-else-if="status == 4" class="bold">问题件</span>
            <span v-else class="bold">暂无</span>
          </span>
          <span>
            <span>运单编号：</span>
            <span>{{ info.supply_express_id }}</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 头部数据栏 -->
    <div class="topList" v-if="stateType == 1">
      <div class="flexItem">
        <span>退单编号：{{ info.refund_nbr }}</span>
      </div>
      <div class="flexItem">
        <span>申请原因</span>
        <span style="color: #999">{{ info.refund_reason || "" }}</span>
      </div>
      <div
        class="flexItem"
        v-if="
          (info.refund_type == '3' || info.refund_type == '5'|| info.refund_type == '9') &&
          (info.supply_express_id ||
            info.refund_express_id ||
            info.pickup_state == 3|| info.pickup_state == 6)
        "
      >
        <span>寄件方式</span>
        <span style="color: #999">{{
          info.is_pickup == 0 ? "自己寄件" : "上门取件"
        }}</span>
      </div>
      <div
        class="flexItem"
        v-if="
          !(info.refund_type == '6' || info.refund_type == '7') &&
          info.refund_amount
        "
      >
        <span>退款总金额</span>
        <span style="color: #e02020"
          >￥{{ parseFloat(info.refund_amount || "") }}</span
        >
      </div>
      <div
        class="flexItem"
        v-if="info.is_pickup == '0' && info.al_name"
      >
        <span>支付宝姓名</span>
        <span>{{ info.al_name || "" }}</span>
      </div>
      <div
        class="flexItem"
        v-if="info.is_pickup == '0' && info.alaccount"
      >
        <span>支付宝账户</span>
        <span>{{ info.alaccount || "" }}</span>
      </div>
       <div
        class="flexItem"
        v-if="info.refund_type == '6' && info.refund_name"
      >
        <span>补偿姓名</span>
        <span>{{ info.refund_name || "" }}</span>
      </div>
      <div
        class="flexItem"
        v-if="info.refund_type == '6' && info.refund_account"
      >
        <span>补偿账户</span>
        <span>{{ info.refund_account || "" }}</span>
      </div>
      <div class="flexItem" v-if="info.refund_type == '6' && info.repay_amount">
        <span>补偿金额</span>
        <span>{{ info.repay_amount || "" }}</span>
      </div>
    </div>
    <!-- 下面数据栏 -->
    <div class="bottomList" v-if="stateType < 4">
      <div v-if="stateType == 1 && info.refuse_refund_reason">
        <div class="title">{{info.refund_state == 4?'失败理由':'售后理由'}}</div>
        <div class="desc">{{ info.refuse_refund_reason }}</div>
      </div>
      <div v-if="stateType == 1 && info.refund_note">
        <div class="title">问题描述</div>
        <div class="desc">{{ info.refund_note }}</div>
      </div>
      <div
        style="margin-bottom: 0.4rem"
        v-if="
          stateType == 1 && info.refund_image && info.refund_image.length > 0
        "
      >
        <div class="title">上传图片</div>
        <div class="imgArr">
          <img
            :src="img + `${imgCrop}resize,w_200`"
            v-for="(img, index) in info.refund_image"
            @click="showImageArr(info.refund_image, index)"
            :key="index"
          />
        </div>
      </div>
      <div>
        <div class="commodityTitle">
          <div class="title" style="padding:0">售后清单</div>
          <div class="orderNbr">订单编号：{{ info.order_nbr }}</div>
        </div>
        <div class="commodity">
          <div style="display: flex" v-if="info.commodity">
            <img :src="info.commodity[0].commodity_logo" alt />
            <div class="rightArea">
              <span class="more-h commodityName">{{
                info.commodity[0].commodity_name
              }}</span>
              <span class="more-h property"
                >规格：{{ info.commodity[0].property }}</span
              >
              <div class="last">
                <span class="price"
                  >￥{{ parseFloat(info.commodity[0].sell_price) }}</span
                >
                <span class="quantity">x{{ info.commodity[0].quantity }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 0.2rem" v-if="(stateType == 1||stateType == 2) && info.commodity">
        <div class="flexItem" style="">
          <span>退单编号：{{ info.refund_nbr }}</span>
        </div>
        <div class="flexItem">
          <span>总金额</span>
          <span
            >￥{{
              parseFloat(info.commodity[0].sell_price) *
              parseFloat(info.commodity[0].quantity)
            }}</span
          >
        </div>
        <div class="flexItem">
          <span>优惠金额</span>
          <span>￥{{ parseFloat(info.coupon_amount) }}</span>
        </div>
        <div class="flexItem">
          <span>运费</span>
          <span>￥{{ parseFloat(info.postage) }}</span>
        </div>
        <div class="flexItem" v-if="parseFloat(info.postage_safe) > 0">
          <span>运费险</span>
          <span>￥{{ parseFloat(info.postage_safe) }}</span>
        </div>
        <div class="flexItem">
          <span>实付金额</span>
          <span style="color: #e02020"
            >￥{{ parseFloat(info.sum_amount) }}</span
          >
        </div>
      </div>
    </div>
    <!-- 下面数据栏 -->
    <div class="expressSend" v-if="stateType == 4">
      <div class="sendbox">
        <span>快递公司：{{info.pickup.express_name}}</span>
        <span>快递单号：{{info.pickup.express_id}}</span>
        <span>运费支付：￥{{info.pickup.sum_amount}}元</span>
        <span>揽件时间：{{info.pickup_time}}</span>
      </div>
    </div>
    <div v-if="(stateType == 3&&message.length>0)||stateType == 4">
      <div class="getMessage">
        <div class="title" v-if="stateType == 4">售后历史记录</div>
        <div class="messageList" v-if="stateType == 3">
          <div class="item" v-for="(item, index) in message" :key="index">
            <div class="line" v-if="index < message.length - 1"></div>
            <img
              v-if="index == 0"
              src="../../assets/images/icon_xuanzhong.png"
              alt
            />
            <img v-else src="../../assets/images/icon_no.png" alt />
            <div class="itemInfo">
              <span
                class="desc"
                :style="index == 0 ? 'color:#333' : '#999'"
                v-html="item.AcceptStation"
              ></span>
              <span class="time">{{ item.AcceptTime }}</span>
            </div>
          </div>
        </div>
        <div class="messageList" v-if="stateType == 4">
          <div class="item" v-for="(item, index) in info.list" :key="index">
            <div class="line" v-if="index < info.list.length - 1"></div>
            <img
              v-if="index == 0"
              src="../../assets/images/icon_xuanzhong.png"
              alt
            />
            <img v-else src="../../assets/images/icon_no.png" alt />
            <div class="itemInfo">
              <span
                class="desc"
                :style="index == 0 ? 'color:#333' : '#999'"
              >
                {{item.new_state=='1'?'买家发起了售后申请':
                  item.new_state=='2'?'审核通过，等待买家寄回':
                  item.new_state=='3'?'完成售后':
                  item.new_state=='4'?'售后被拒绝':
                  item.new_state=='5'?'取消售后':
                  item.new_state=='7'?'上门取件预约申请':
                  item.new_state=='8'?'上门取件已接单':
                  item.new_state=='9'?'上门取件揽件成功':
                  item.new_state=='10'?'上门取件失败':
                  item.new_state=='11'?'取消上门取件':
                  item.new_state=='12'?'商家已签收':
                  ''}}
              </span>
              <span class="time">{{ item.create_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonWrap" v-if="stateType == 4">
      <!-- serviceShow = true -->
      <div class="item red" @click="toService()">联系客服</div>
      <div class="item default" @click="toExpress">物流详情</div>
    </div>
    <!-- 底部按钮栏 -->
    <div
      class="bottomButton"
      v-if="
        (info.back_full_address &&
          info.refund_state == 2 &&
          ((!info.refund_express_id &&
            (!info.pickup_state ||
              (info.pickup_state &&
                (info.pickup_state == 4 || info.pickup_state == 5)))) ||
            info.pickup_state == 1 ||
            info.refund_express_id) &&
          (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)) ||
        info.refund_state == 1 ||
        info.refund_state == 4||
        (info.refund_state == 2 &&(info.pickup_state==3||info.pickup_state==6)&&info.pickup&&info.pickup.pay_state=='1')
      "
    >
      <div class="wrap">
        <!-- <div
          class="bottomNotice"
          v-if="info.refund_state==2&&info.pickup_state==1&&(info.refund_type==3||info.refund_type==5)"
        >运费以当前重量评估，实际运费与快递员确认重量为准</div>-->
        <!-- <div
          class="will"
          v-if="info.refund_state==2&&info.pickup_state==1&&(info.refund_type==3||info.refund_type==5)"
        >
          <span>运费预估</span>
          <span class="expressPrice">￥{{'0.00'}}</span>
        </div>-->
        <!-- serviceShow = true -->
        <div
          @click="toService()" 
          class="button default"
          style="margin-right: 0.2rem"
          v-if="info.refund_state == 1 || info.refund_state == 4||(info.back_full_address &&
            info.refund_state == 2 &&
            !info.refund_express_id &&
            (!info.pickup_state ||
              (info.pickup_state &&
                (info.pickup_state == 4 || info.pickup_state == 5))))"
        >
          联系客服
        </div>
        <div
          @click="cancelShow = true"
          class="button default"
          style="margin-right: 0.2rem"
          v-if="(info.refund_state == 1)||(info.back_full_address &&
            info.refund_state == 2 &&
            !info.refund_express_id &&
            (!info.pickup_state ||
              (info.pickup_state &&
                (info.pickup_state == 4 || info.pickup_state == 5))))"
        >
          取消申请
        </div>
        <div
          class="button red"
          @click="toMent"
          v-if="(info.refund_type != 9&&info.refund_type != 8)&&info.refund_state == 4 && info.is_repeat_refund == 0"
        >
          重新申请
        </div>
        <div
          class="button default"
          style="margin-right: 0.2rem"
          v-if="
            info.refund_state == 2 &&
            (info.pickup_state == 1||info.pickup_state == 2) &&
            (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
          "
          @click="cancelSendShow = true"
        >
          取消寄件
        </div>
        <div
          class="button red"
          v-if="
            info.back_full_address &&
            info.refund_state == 2 &&
            !info.refund_express_id &&
            (!info.pickup_state ||
              (info.pickup_state &&
                (info.pickup_state == 4 || info.pickup_state == 5)))
          "
          @click="showMail"
        >
          我要寄件
        </div>
        <div
          class="button default"
          v-if="
            info.refund_state == 2 &&
            info.refund_express_id &&
            (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
          "
          @click="toApply('1')"
        >
          修改物流
        </div>
        <div
          class="button red"
          v-if="
            info.refund_state == 2 &&
            info.pickup_state == 1 &&
            (info.refund_type == 3 || info.refund_type == 5||info.refund_type == 9)
          "
          @click="getdata"
        >
          刷新
        </div>

        <div
          @click="postageDetailShow = true"
          class="button default"
          style="margin-right: 0.2rem"
          v-if="info.refund_state == 2 &&(info.pickup_state==3||info.pickup_state==6)&&info.pickup&&info.pickup.pay_state=='1'"
        >
          运费明细
        </div>
        <div
          class="button red"
          v-if="info.refund_state == 2 &&(info.pickup_state==3||info.pickup_state==6)&&info.pickup&&info.pickup.pay_state=='1'"
          @click="showup=true"
        >
          立即支付
        </div>
      </div>
    </div>
    <!--取消寄件弹窗-->
    <van-popup
      class="closepopup"
      v-model="cancelSendShow"
      :close-on-click-overlay="false"
    >
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">
          <!-- <span>温馨提示</span> -->
          <span>确认要取消寄件？</span>
        </van-row>
        <van-row>
          <van-col class="cancel" @click.native="cancelSendShow = false"
            >取消</van-col
          >
          <van-col class="confirm" @click.native="cancelSend">确认</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--取消申请弹窗-->
    <van-popup
      class="closepopup"
      v-model="cancelShow"
      :close-on-click-overlay="false"
    >
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">
          <!-- <span>温馨提示</span> -->
          <span>确认要取消申请？</span>
        </van-row>
        <van-row>
          <van-col class="cancel" @click.native="cancelShow = false"
            >取消</van-col
          >
          <van-col class="confirm" @click.native="cancel">确认</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!-- 客服弹窗 -->
    <van-popup v-model="serviceShow" style="border-radius: 0.2rem">
      <div class="servicebox">
        <img
          class="serviceimg"
          @click="serviceShow = false"
          src="./../../assets/images/information/Close.svg"
          alt
        />
        <div class="servicespan">
          <p class="wechat">有米日记服务中心</p>
          <span>有米日记售后系统上线啦！</span>
          <span>长按识别小程序码，即可体验全新售后体验</span>
          <!--<span>菜单底部直接联系客服</span>-->
        </div>
        <div class="codeimg">
          <img src="./../../assets/images/xcx_qrcode.jpg" alt />
        </div>
      </div>
    </van-popup>

    <!-- 选择寄件弹窗 -->
    <van-popup position="bottom" :overlay="true" v-model="mailShow" class="chooseMail">
      <div class="chooseItem" style="border-bottom:1px solid #e5e5e5;height:1.25rem" @click.stop="toApply('0')">
        <span>上门取件</span>
        <!-- <span v-if="parseFloat(info.postage_safe) > 0&&info.is_full_postage_pay=='0'" style="font-size:.22rem;color:#E90E0E;line-height:.3rem">先自行支付运费，售后完成48小时内系统自动全额补偿运费</span>
        <span v-else-if="parseFloat(info.postage_safe) > 0&&info.is_full_postage_pay=='1'" style="font-size:.22rem;color:#E90E0E;line-height:.3rem">先自行支付运费，售后完成48小时内系统自动按照运费险协议补偿运费</span>
        <span v-else style="font-size:.22rem;color:#E90E0E;line-height:.3rem">快递员上门取件，免填地址，自动回单。</span> -->
      </div>
      <div class="chooseItem" @click.stop="toApply('1')" style="height:1.25rem">
        <span>自己寄件</span>
        <!-- <span style="font-size:.22rem;color:#999;line-height:.3rem">运费自行支付/垫付(运费审核完成后，自动赔付)</span> -->
      </div>
      <div class="chooseItem" @click.stop="mailShow=false" style="margin-top:.16rem">
        <span>取消</span>
      </div>
    </van-popup>

    <!-- 邮费明细弹窗 -->
    <van-popup position="bottom" :overlay="true" v-model="postageDetailShow" class="detailContent">
      <div class="detailItem" style="height:1.3rem">
        <span style="font-size:.3rem;font-weight:'bold'">{{info.pickup&&(info.pickup.city!='市辖区'?info.pickup.city:info.pickup.province)}}-{{info.address&&(info.address.city!='市辖区'?info.address.city:info.address.province)}}</span>
        <img style="width:.34rem;height:.34rem" src="./../../assets/images/replacementdetail/closeDetails.png" alt  @click.stop="postageDetailShow=false"/>
      </div>
      <div class="detailItem">
        <span>计费类型</span>
        <span>按重量计费</span>
      </div>
      <div class="detailItem">
        <span>首重费</span>
        <span>￥{{info.pickup&&info.pickup.first_weight_amount}}</span>
      </div>
      <div class="detailItem">
        <span>续重</span>
        <span>￥{{info.pickup&&info.pickup.continuous_weight_amount}}</span>
      </div>
      <div class="detailItem" v-if="info.pickup&&parseFloat(info.pickup.postage_pay)>0">
        <span>运费险抵扣</span>
        <span style="color:#E52B25">-￥{{info.pickup&&info.pickup.postage_pay}}</span>
      </div>
      <div class="detailItem">
        <span>实付金额</span>
        <span>￥{{info.pickup&&info.pickup.sum_amount}}</span>
      </div>
    </van-popup>

    <!-- 支付弹窗 -->
    <van-popup
    v-model="showup"
    position="bottom"
    :overlay="true"
    @click-overlay="showup = false;"
  >
    <div class="paypopup">
      <div class="paypopup-close">
        <div class="paypopup-closel-x">请选择支付方式</div>
        <div class="paypopup-closel" @click="showup = false;">
          <img src="../../assets/images/icon_close.svg" alt />
        </div>
      </div>
      <div class="paypopup-amount">支付金额:￥{{info.pickup&&info.pickup.sum_amount}}</div>
      <div class="paypopup-weixin" @click="xuanz2">
        <div class="paypopup-weixinl">
          <img src="../../assets/images/icon_wxzf.svg" alt />
          <span>微信支付</span>
        </div>
        <div class="paypopup-weixinr">
          <img v-if="payState==1" :src="require('../../assets/images/icon_xuanzhong.png')" alt />
          <div class="radius1" v-else></div>
        </div>
      </div>
      <div class="linew"></div>
      <div
        :class="payState==3?'paypopup-weixin':'paypopup-weixin '"
        @click="xuanz4"
      >
        <div class="paypopup-weixinl">
          <img src="../../assets/images/aliPay.png" alt />
          <span>支付宝支付</span>
        </div>
        <div class="paypopup-weixinr">
          <div class="radius1" v-if="payState!=3"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
        </div>
      </div>
      <div
        class="paypopup-pay"
        @click="gopay"
      >立即支付</div>
    </div>
  </van-popup>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "../../assets/js/tool";
import ap from "@/assets/js/ap";

export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      serviceShow: false,
      cancelSendShow: false,
      cancelShow: false,
      tuiShow: false,
      id: this.$route.query.nbr,
      info: "",
      expressBird: "",
      countTime: "",
      time: "2020-06-26 15:50:18",
      YesYsf: 0,
      stateType: "",
      message: [],
      status: "",
      statusEx: "",
      mailShow:false,

      postageDetailShow:false,
      showup:false,
      payState:'1',
      paymoney:'',
      goPaySwitch:true,
      weChatProp: {},
      weChatSwitch:true,
      aliUrl_ys:'',
      userData:{},
    };
  },
  watch: {},
  methods: {
    toService(){
      let item = this.info
      let note = {
        refundNbr: this.info.refund_nbr
      }
      let time=new Date(item.create_time).getTime()/1000
      let adminUrl=`https://ymrjmanager.kjyoumi.com/ysfIframe?openid=${this.userInfo.nbr}&note=${JSON.stringify(note)}`
      let goods = item.commodity[0]
      let orderInfo=`tmptype=order&tmpTitle=${encodeURIComponent(goods.commodity_name)}&tmporderThumb=${encodeURIComponent(goods.commodity_logo)}&tmporderid=${item.refund_nbr}&tmpordertime=${time}&tmpordernum=${goods.quantity}&tmporderprice=${item.sum_amount}&tmporderstaffurl=${encodeURIComponent(adminUrl)}&isauto=0`
      let url = `https://kefu.kjyoumi.com/api/mobileweb/home?channel_id=34483&channel_key=34483zkeq&wechatapp_id=345097&key=76967s450&openid=${this.userInfo.nbr}&nickName=${encodeURIComponent(this.userData.nick_name)}&avatarUrl=${encodeURIComponent(this.userData.head_pic)}&mobile=${this.userData.phone_no||''}&note=${JSON.stringify(note)}&${orderInfo}`
      let u = navigator.userAgent
      let isandroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1;
      if(isandroid) url=url+'&isvivo=1'
      // window.open(url)
      this.$router.push({
        path: "/iframe",
        query: {
          title: encodeURIComponent('在线客服'),
          url: encodeURIComponent(url),
        },
      });
    },
    xuanz2() {
      this.payState = 1;
      this.$forceUpdate();
    },
    xuanz4() {
      this.payState = 3;
      this.$forceUpdate();
    },
    gopay() {
      if (!this.goPaySwitch) return false;
      this.goPaySwitch = false;
      let that = this;

      let toast = this.$toast.loading({
        mask: true,
        message: "支付中..."
      });
      
      if (this.payState == 1) {
        that.payType = "YOUTHSNEWPUBLICPAY";
      } else if (this.payState == 3) {
        that.payType = "YOUTHSNEWALIPAYWAP";
      }
      async function readyPay() {
        return new Promise((resolve, reject) => {
          that.readyPay(resolve, reject);
        });
      }
      async function pay() {
        if (
          that.payType == "YOUTHSNEWPUBLICPAY" ||
          that.payType == "UNIONPUBLICPAY"
        ) {
          return new Promise((resolve, reject) => {
            that.weChatPay(resolve, reject);
          });
        }if (that.payType == "YOUTHSNEWALIPAYWAP") {
          return new Promise((resolve, reject) => {
            that.AliPay_ys(resolve, reject);
          });
        } 
      }
      async function goPayMoney() {
        await readyPay();
        await pay();
      }
      goPayMoney();
    },
    readyPay(resolve, reject) {
      let that = this;
      let openid = localStorage.getItem("openid");
      that.$post("/api/kdniao/readyPay", {
          userNbr: that.userInfo.nbr,
          refundNbr: that.id,
          paymentMethod: that.payType,
          openid: openid
        })
        .then(data => {
          if (that.payType == "ALIPAYWAP") {
            that.aliUrl = data;
            resolve();
            return false;
          }
          if (data.code == 200) {
            let resp = data.object.resp;
              if (that.payType == "YOUTHSNEWALIPAYWAP") {
              that.aliUrl_ys = resp.resp.prepayUrl;
              resolve();
              return false;
            }
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              if (
                that.payType == "YOUTHSNEWPUBLICPAY" ||
                that.payType == "UNIONPUBLICPAY" ||
                that.payType == "YOUTHSPUBLICPAY"
              ) {
                that.weChatProp = resp.resp;
                resolve();
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: res.resp_msg,
                duration: 2000
              });
            }
          } else {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: data.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          reject();
          that.goPaySwitch = true;
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    weChatPay(resolve, reject) {
      let that = this;
      let weChatPayInfo = that.weChatProp;
      function jsApiCall() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: weChatPayInfo.appId, //公众号名称，由商户传入
            timeStamp: weChatPayInfo.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: weChatPayInfo.nonceStr, //随机串
            package: "prepay_id=" + weChatPayInfo.prepayid,
            signType: weChatPayInfo.signType, //微信签名方式：
            paySign: weChatPayInfo.sign //微信签名
          },
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.checkWeChatSuccess(resolve, reject);
              let timer = setTimeout(() => {
                that.weChatSwitch = false;
              }, 60000);
            } else if (
              res.err_msg == "get_brand_wcpay_request:cancel" ||
              res.err_msg == "get_brand_wcpay_request:fail"
            ) {
              that.goPaySwitch = true;
              that.showup = false;
              that.$toast({
                message: "支付失败",
                duration: 2000
              });
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", jsApiCall);
          document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
        }
      } else {
        jsApiCall();
      }
    },
    AliPay_ys() {
      let that = this;
      let aliUrl =  that.aliUrl_ys;
      _AP.pay(aliUrl);
    },
    checkWeChatSuccess(resolve, reject){
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_40072",
          refund_nbr: this.id,
        },
      })
        .then((resp) => {
          if (resp.resp_code == 0 && resp.resp_result == 0) {
            if(resp.pay_state=='2'){
              this.$toast({
                message: "支付成功!",
                duration: 2000,
              });
               this.getdata()
              resolve();
              this.showup = false;
            }else{
              setTimeout(() => {
                this.checkWeChatSuccess(resolve, reject);
              }, 1000);
            }
          }else{
            this.$toast({
              message: "支付失败",
              duration: 2000
            });
            this.getdata()
            reject();
            this.showup = false;
          }
         
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },


    copy() {
      let copyBtn = new this.$clipboard(".copyBtn");
      copyBtn.on("success", (e) => {
        this.$toast({
          message: "复制成功",
          duration: 2000,
        });
      });
      copyBtn.on("error", (e) => {
        this.$toast({
          message: "复制失败",
          duration: 2000,
        });
      });
    },
    cancel() {
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_40021",
          user_nbr: this.userInfo.nbr,
          nbr: this.id,
        },
      })
        .then((response) => {
          this.$toast({
            message: "取消申请成功!",
            duration: 2000,
          });
          this.getdata();
          this.tuishow = false;
          this.$store.commit("SENDpayment", 1);
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    cancelSend() {
      let that = this;
      let toast = this.$toast.loading({
        mask: false,
        duration: 0,
      });
      that.$post("/api/kdniao/cancelOrderOnline", {
          userNbr: that.userInfo.nbr,
          refundNbr: that.$route.query.nbr,
        })
        .then((res) => {
          let resp = res.object ? res.object.resp : {};
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              this.$toast({
                message: "取消成功",
                duration: 2000,
              });
              this.getdata();
            } else {
              this.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            this.$toast({
              message: res.data.message,
              duration: 2000,
            });
          }
          toast.clear();
          this.cancelSendShow = false;
        })
        .catch((err) => {
          toast.clear();
          this.cancelSendShow = false;
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    getExpress() {
      let that = this;
      that.$post("/api/customer/expressKDN", {
          userNbr: that.userInfo.nbr,
          expressId: that.info.supply_express_id,
          customerName:
            that.info.supply_express_name == "京东快递"
              ? that.info.supply_express_note
                ? that.info.supply_express_note
                : that.info.phone_no
              : that.info.phone_no,
          expressName: that.info.supply_express_name,
        })
        .then((res) => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              if (resp.express && resp.express.State > 0) {
                that.status = resp.express.State;
                that.statusEx = resp.express.StateEx;
                that.message = resp.express.Traces.reverse();
              }
            }
          }
        })
        .catch((err) => {
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    toMent() {
      this.$router.push({
        path: "/replacement",
        query: {
          nbr: this.info.commodity[0].commodity_record_nbr,
          supNbr: this.userInfo.nbr,
          type:
            this.info.refund_type == 3
              ? 0
              : this.info.refund_type == 5
              ? 2
              : this.info.refund_type == 6
              ? 3
              : this.info.refund_type == 7
              ? 4
              : 1,
        },
      });
    },
    toExpress() {
      this.$router.push({
        path: "/logistics",
        query: {
          pageType:'2',
          final_phone: this.info.address.phone_no.slice(7, 11),
          supNbr: this.userInfo.nbr,
          express_id: this.info.pickup.express_id,
          express_name:this.info.pickup.express_name,
          nbr:this.info.commodity[0].commodity_record_nbr,
        },
      });
    },
    showMail(){
      if(this.info.supplier_address){
        this.mailShow=true
      }else{
        this.toApply('1')
      }
    },
    toApply(type) {
      this.$router.push({
        path: "/expressApply",
        query: {
          nbr: this.id,
          type: type || "0",
        },
      });
    },
    showImageArr(img, index) {
      wx.previewImage({
        current: img[index],
        urls: img,
      });
    },
    getdata() {
      let toast = this.$toast.loading({
        mask: false,
        duration: 0,
      });
      this.$commonPost({
        jydm: "flow_40002",
        flow_40002: {
          refund_nbr: this.id,
          wechat_version: "1",
        },
      })
        .then((response) => {
          let arr = [];
          if (response.commodity.length > 0) {
            arr = response.commodity;
          } else {
            arr.push(response.commodity);
          }
          if(response.pickup&&response.pickup.address_sender){
            response.pickup.address_sender = handleText(response.pickup.address_sender)
          }
          response.commodity = arr;
          response.refund_image =
            response.refund_image && response.refund_image.split(",");
          this.info = response;
          this.checkState(toast);
          if (this.$route.query.state == 3) this.getExpress();
        })
        .catch((err) => {
          toast.clear();
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    checkState(toast) {
      if (
        this.info.refund_state == 3 &&
        (this.info.refund_type == 7 || this.info.refund_type == 5)
      ) {
        this.stateType = 3;
        toast.clear();
      }else if (
        this.info.refund_state == '2' &&
        this.info.is_pickup=='1' &&
        (this.info.pickup_state == 3||this.info.pickup_state == 6)&&
        this.info.pickup.pay_state=='2'
      ) {
        this.stateType = 4;
        toast.clear();
      } else if (
        this.info.refund_state == '2' &&
        this.info.pickup_state &&
        (this.info.pickup_state == 1 || this.info.pickup_state == 2||( (this.info.pickup_state == 3||this.info.pickup_state == 6)&&this.info.pickup.pay_state=='1')) // 快递上门
      ) {
        this.stateType = 2;
        toast.clear();
        // this.getExpressBird(toast);
      } else {
        this.stateType = 1;
        toast.clear();
      }
    },
    getExpressBird(toast) {
      this.$post("/api/kdniao/queryOrderOnline", {
          userNbr: this.userInfo.nbr,
          refundNbr: this.$route.query.nbr,
        })
        .then((res) => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              resp.pickup.getTime =
                resp.pickup.startTime.split(" ")[0] +
                " " +
                resp.pickup.startTime.split(" ")[1] +
                "-" +
                resp.pickup.endTime.split(" ")[1];
              this.expressBird = resp.pickup;
              this.stateType = 2;
            } else {
              this.stateType = 1;
              this.$toast({
                message: resp.resp_msg,
                duration: 2000,
              });
            }
          } else {
            this.stateType = 1;
            this.$toast({
              message: res.data.message,
              duration: 2000,
            });
          }
          toast.clear();
        })
        .catch((err) => {
          this.stateType = 1;
          toast.clear();
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    timeStamp() {
      let date = new Date();
      let endTime = this.time.replace(/\-/g, "/");
      let nowTime = `${date.getFullYear()}/${
        date.getMonth() + 1
      }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(endTime) - new Date(nowTime)) / 1000;
      let timeText = ``;
      if (timeTamp <= 0) {
        timeText = `00:00:00`;
      } else {
        timeText = `${this.addZero(
          parseInt(timeTamp / (60 * 60 * 24))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(parseInt((timeTamp % (60 * 60)) / 60))}`;
      }
      this.countTime = timeText;
    },
    addZero(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    initPage() {
      this.getdata();
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl,
      };
      this.weChatShare(option);
    },
    getUserInfo(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr,
        },
      }).then((resp) => {
        this.userData = resp;
      }).catch((err) => {});
    },
  },
  created() {},
  mounted() {
    document.title = "售后详情";
    this.initPage();
    this.getUserInfo();
    this.timeStamp();
    this.YesYsf = localStorage.getItem("otherConfig_10013");
  },
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.wrapper {
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 2.03rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.buttonWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
  .item {
    width: 2.48rem;
    height: 0.7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    font-weight: 500;
    border-radius: 0.4rem;
    &.default {
      border: 1px solid #333;
      color: #333;
      margin-left: 0.32rem;
    }
    &.red {
      background: #e52b25;
      color: #fff;
    }
  }
}
.header {
  background-image: linear-gradient(180deg, #e52b25 0%, #ff6360 100%);
  padding: 0.2rem 0.24rem;
  box-sizing: border-box;
  margin-bottom: 0.24rem;
  .headerBox {
    width: 7.02rem;
    height: 2.7rem;
    box-sizing: border-box;
    padding-top: 0.36rem;
    border-radius: 0.14rem;
    background: #fff;
    .time {
      padding-left: 0.3rem;
      height: 0.33rem;
      margin-bottom: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: #666;
        font-size: 0.24rem;
        font-weight: 500;
      }
    }
  }
  .stateArea {
    padding-left: 0.3rem;
    height: 0.4rem;
    margin-bottom: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      color: #333;
      font-size: 0.28rem;
      font-weight: bold;
    }
  }
  .process {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.63rem;
    margin-bottom: 0.2rem;
    .spot {
      width: 0.24rem;
      height: 0.24rem;
      border-radius: 0.12rem;
      box-sizing: border-box;
      border: 1px solid #e52b25;
      &.disabled {
        border: 1px solid #999;
      }
      &.active {
        background: #e52b25;
      }
    }
    .line {
      flex: 1;
      margin: 0 0.1rem;
      height: 1px;
      box-sizing: border-box;
      background: #e52b25;
      &.disabled {
        background: #e0e0e0;
      }
    }
  }
  .processName {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.27rem;
    .processItemName {
      color: #333;
      font-size: 0.24rem;
      &.disabled {
        color: #999;
      }
      &.active {
        color: #e52b25;
      }
    }
  }
}
.topNotice {
  padding: 0.22rem 0.3rem;
  font-weight: 600;
  line-height: 0.42rem;
  font-size: 0.3rem;
}
.express {
  .top {
    background: #ffffff;
    height: 1.98rem;
    display: flex;
    .left {
      width: 2.18rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 1.7rem;
        height: 1.7rem;
        object-fit: cover;
        border-radius: 0.04rem;
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      width: 5.2rem;
      height: 100%;
      padding: 0.24rem 0;
      box-sizing: border-box;
      justify-content: space-evenly;
      span {
        font-family: 500;
        font-size: 0.26rem;
        color: #666;
        &.bold {
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
}
.notice {
  padding: 0.2rem 0.24rem;
  font-weight: 400;
  line-height: 0.37rem;
  font-size: 0.26rem;
}
.topList {
  padding: 0.15rem 0.3rem;
  background: #fff;
}
.expressSend {
  width: 100%;
  padding: 0.24rem;
  background: #fff;
  box-sizing: border-box;
  .sendbox {
    background: #f2f2f2;
    width: 100%;
    padding: 0.3rem 0.3rem 0;
    border-radius: 0.1rem;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    span {
      font-size: 0.28rem;
      color: #333;
      margin-bottom: 0.3rem;
    }
  }
}
.bottomList {
  padding: 0.01rem 0.3rem 0.2rem;
  background: #fff;
  margin-top: 0.2rem;
  .title {
    padding: 0.2rem 0;
    line-height: 0.42rem;
    font-size: 0.3rem;
    font-weight: 500;
  }
  .desc {
    line-height: 0.34rem;
    font-size: 0.24rem;
    color: #999;
    font-weight: 500;
  }
  .imgArr {
    display: flex;
    align-items: center;
    img {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.08rem;
      object-fit: cover;
      margin-left: 0.23rem;
      &:first-child {
        margin: 0;
      }
    }
  }
}
.stateText {
  font-size: 0.48rem;
  line-height: 0.68rem;
  font-weight: 600;
}
.commodityTitle{
  width: 100%;
  height: .72rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.orderNbr {
  font-size: 0.24rem;
  color: #333;
  font-weight: 500;
}
.commodity {
  padding: 0.24rem 0;
  box-sizing: border-box;
  height: 2.3rem;
  width: 100%;
  img {
    width: 1.8rem;
    height: 1.8rem;
    object-fit: cover;
    border-radius: .16rem;
  }
  .rightArea {
    margin-left: 0.14rem;
    position: relative;
    flex: 1;
    .commodityName {
      font-size: 0.26rem;
      font-weight: 500;
      color: #333;
      line-height: 0.32rem;
    }
    .property {
      margin-top: 0.1rem;
      font-size: 0.22rem;
      font-weight: 500;
      color: #999;
      line-height: 0.3rem;
    }
    .last {
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .price {
        font-size: 0.3rem;
        color: #e52b25;
        font-weight: 500;
      }
      .quantity {
        font-size: 0.24rem;
        color: #333;
        font-weight: bold;
      }
    }
  }
}
.timeArea {
  display: flex;
  align-items: center;
  background: #fff;
  .titleKey {
    padding-left: 0.24rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
  }
  .timeCountBox {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
    padding-right: 0.24rem;
    .timeA {
      font-size: 0.24rem;
      font-weight: 500;
      color: #fff;
      width: 0.44rem;
      height: 0.44rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #000;
      border-radius: 0.08rem;
      margin: 0 0.06rem;
    }
  }
  .span {
    color: #333;
    font-size: 0.34rem;
    font-weight: 400;
    flex: 1;
    height: 0.84rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &.active {
      color: #e52b25;
    }
    &.active::after {
      content: "";
      width: 1.02rem;
      height: 0.04rem;
      border-radius: 0.02rem;
      background: #e52b25;
      position: absolute;
      bottom: 0;
    }
  }
}
.itemArea {
  padding: 0.3rem;
  border-top: 1px solid #eee;
  background: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 0.26rem;
  font-weight: 500;
  line-height: 0.32rem;
  .key {
    color: #999;
    width: 1.04rem;
    line-height: 0.32rem;
    white-space: nowrap;
  }
  .selectRight {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    margin-left: 0.36rem;
    img {
      width: 0.3rem;
      height: 0.3rem;
      margin-left: 0.05rem;
    }
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.flexItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.15rem 0;
  span {
    color: #333;
    font-size: 0.3rem;
    line-height: 0.42rem;
  }
}
.getExpressNotice {
  margin-top: 0.1rem;
  color: #999;
  font-size: 0.24rem;
  font-weight: 500;
  line-height: 0.34rem;
  margin-left: 0.24rem;
}
.bottomButton {
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 1.03rem;
  z-index: 2;
  background: #fff;
  padding: 0 0.3rem;
  box-sizing: border-box;
  .wrap {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .button {
    width: 2.1rem;
    height: 0.74rem;
    border-radius: 0.4rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    &.default {
      color: #333;
      border: 1px solid #333;
    }
    &.red {
      color: #fff;
      background: #e52b25;
    }
  }
  .bottomNotice {
    position: absolute;
    top: -0.38rem;
    color: #999;
    font-size: 0.22rem;
    left: 0;
  }
  .will {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0.2rem;
    span {
      font-size: 0.24rem;
      line-height: 0.3rem;
      color: #999;
    }
    .expressPrice {
      color: #e52b25;
      margin-top: 0.06rem;
      display: inline-block;
      font-weight: bold;
    }
  }
}
.getMessage {
  margin-top: 0.2rem;
  background: #fff;
  padding: 0 0.24rem;
  color: #333;
  .title {
    font-size: 0.26rem;
    font-weight: bold;
    height: 0.88rem;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
  }
  .messageList {
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 0.4rem 0 0.2rem;
    .item {
      display: flex;
      padding-bottom: 0.4rem;
      overflow: hidden;
      position: relative;
      .line {
        border-left: 0.02rem dashed #ccc;
        position: absolute;
        left: 0.19rem;
        top: 0;
        height: 100%;
        width: 1px;
        z-index: 1;
      }
      img {
        width: 0.4rem;
        height: 0.4rem;
        background: #fff;
        z-index: 2;
      }
      .itemInfo {
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        margin-left: 0.16rem;
        .desc {
          color: #999;
          line-height: 0.32rem;
          word-break: break-all;
        }
        .time {
          margin-top: 0.1rem;
          color: #999;
        }
      }
    }
  }
}
.servicebox {
  width: 6.14rem;
  height: 7.66rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.34rem 0 rgba(239, 51, 66, 0.12);
  .serviceimg {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
  }
  .servicespan {
    padding-top: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 0.26rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.62rem;
    span {
      line-height: 0.4rem;
    }
    .wechat {
      font-size: 0.4rem;
      color: #000000;
      font-weight: bold;
      margin-bottom: 0.1rem;
      line-height: 0.56rem;
    }
  }
  .codeimg {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 4rem;
      height: 4rem;
    }
  }
}
.closepopup {
  border-radius: 0.18rem;
}
.popup {
  width: 6.14rem;
  height: 3.04rem;
  .content {
    height: 1.95rem;
    text-align: center;
    font-size: 0.3rem;
    color: #333333;
    flex-direction: column;
    span:first-of-type {
      font-weight: 500;
      font-size: 0.3rem;
    }
  }
  .cancel {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-size: 0.3rem;
    color: #333333;
    background: #ffffff;
    border-right: 1px solid #eeeeee;
    border-top: 1px solid #eeeeee;
  }
  .confirm {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    background: #ffffff;
    font-size: 0.3rem;
    color: #e52b25;
    border-top: 1px solid #eeeeee;
  }
}
.postAddress {
  margin-bottom: 0.2rem;
  padding: 0.3rem;
  font-size: 0.26rem;
  color: #999;
  line-height: 0.32rem;
  background: #fff;
  display: flex;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0.3rem;
    height: 1px;
    width: calc(100% - 0.6rem);
    background: #eee;
  }
  .postKey {
    white-space: nowrap;
  }
  .right {
    flex: 1;
    margin-left: 0.2rem;
    .postTop {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      // margin-bottom: 0.1rem;
      color: #333;
      .left {
        width: 4.26rem;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        span {
          display: inline-block;
        }
      }
      .copyBtn {
        width: 1.12rem;
        height: 0.4rem;
        border-radius: 0.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #333;
        span {
          font-size: 0.2rem;
          color: #333;
        }
      }
    }
  }
}
.chooseMail{
  border-top-right-radius: .16rem;
  border-top-left-radius: .16rem;
  background: #f5f5f5;
  height: 3.58rem;
  display: flex;
  flex-direction: column;
  .chooseItem{
    width: 100%;
    height: 1.14rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span{
      font-size: .32rem;
      color: #333;
      line-height: .45rem;
    }
  }
}

.detailContent{
  width: 100%;
  background: #fff;
  border-top-left-radius: .26rem;
  border-top-right-radius: .26rem;
  overflow: hidden;
  .detailItem{
    width: 100%;
    height: 1rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 .36rem;
    span{
      font-size:.26rem;
      color: #333;
    }
  }
}

.paypopup {
  width: 100%;
  //height: 6.96rem;
}
.paypopup-closel-x {
  font-weight: bold;
  font-size: 0.34rem;
  color: #333333;
  margin: 0 auto;
}
.paypopup-close {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.08rem;
  margin-bottom: 0.1rem;
}
.paypopup-close img {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0.34rem;
  right: 0.24rem;
}
.paypopup-amount {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 0.65rem;
  font-size: 0.46rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.4rem;
}

.radius {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.radius1 {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #333;
  box-sizing: border-box;
}
.paypopup-weixinr img {
  width: 0.42rem !important;
}
.paypopup-weixinl img {
  width: 0.4rem;
}

.paypopup-weixin {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 0.98rem;
  padding: 0 0.36rem;
  padding-right: 0.44rem;
}

.paypopup-weixinl span {
  margin-left: 0.28rem;
  font-size: 0.28rem;
  line-height: 1.08rem;
}

.paypopup-pay {
  //width: 6.94rem;
  height: 0.98rem;
  background: #e52b25;
  line-height: 0.98rem;
  font-size: 0.3rem;
  text-align: center;
  color: #fff;
  margin-top: 1rem;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/information/replacementdetail.vue